import type { FaireProductEntity } from "../../entity_types/product";

export const p_ttydgdnkbg: FaireProductEntity = {
  token: "p_ttydgdnkbg",
  type: "product",
  name: "Silver Laxmi Note 10 Gms",
  brandToken: "b_ftaz83cznh",
  brandName: "Ancientveda",
  imageUrl:
    "https://cdn.faire.com/fastly/a6d962db507c2175e0fb49d04f6142816ea1a58e0cef534178f6bd93651df8c5.jpeg",
  galleryImageUrls: [],
  priceDollars: 36.58,
  description:
    "Celebrate Diwali, the Festival of Lights, with our exquisite range of Indian Diwali goods. Immerse yourself in the festivity with our hand-picked selection – ornate diyas to cast a warm, welcoming glow, vibrant rangolis for a touch of auspicious art, and eco-friendly decorations to beautify your space sustainably. Savor the season with traditional sweets crafted from time-honored recipes. Whether gifting loved ones or adorning your home, our products promise to enhance the joy and spirit of Diwali.",
  tags: [],
  msrpDollars: 91.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:11.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
